/*
 * Public API Surface of ngx-cookie-service-ssr
 */

export * from './lib/ssr-cookie.service';
